module.exports = __webpack_public_path__ + "img/font_plus.1c5bff70.svg";